import { HomeContentView } from "components/materials/home/HomeContentView";
import { HomeRole } from "utils/urls";

/**
 * Note that instructors and students share the same home view, just with slightly different controls.
 */
export default function Page() {
  return <HomeContentView homeRole={HomeRole.SECTION_ASSISTANT} />;
}
